/*
 * @Description: 
 * @Author: git config user.name
 * @Date: 2025-03-24 08:56:07
 * @LastEditors: git config user.name
 * @LastEditTime: 2025-03-24 14:39:32
 * @FilePath: \ngs_platform_manage_admin\src\api\modules\pageConfiguration.js
 */
// 网站自定义页面 接口集合
import request from '../request.js'

// 列表展示,数据查询  ============孙强
export const getDefinePageList = function (data) {
    return request({
        url: '/definePage/getDefinePageList',
        method: 'post',
        data
    })
}

// 新增/编辑保存 ============孙强
export const saveOrEditDefinePage = function (data) {
    return request({
        url: '/definePage/saveOrEditDefinePage',
        method: 'post',
        data
    })
}


// 启用/禁用 ============孙强
export const setPageEnableOrDisable = function (data) {
    return request({
        url: '/definePage/setPageEnableOrDisable',
        method: 'post',
        data
    })
}